const COLLECTION_ACCESSORIES_CART_DRAWER_OPEN_FALLBACK_MS = 550;

function setAccessoriesAddToCartLoadingState(button, isLoading) {
    if (!button) return;

    button.classList.toggle("is-loading", isLoading);
    button.disabled = isLoading;

    if (isLoading) {
        button.setAttribute("aria-busy", "true");
        return;
    }

    button.removeAttribute("aria-busy");
}

function waitForAccessoriesCartDrawerOpen(onComplete) {
    const cartWrap = typeof ajaxcart !== "undefined" && ajaxcart.cartWrap ? ajaxcart.cartWrap : document.querySelector(".bouliesCartWrap");
    const cartDrawer = cartWrap?.querySelector(".bouliesCart") || document.querySelector(".bouliesCart");
    let timeoutId = null;

    function finish() {
        if (timeoutId === -1) return;

        clearTimeout(timeoutId);
        timeoutId = -1;
        cartWrap?.removeEventListener("transitionend", handleTransitionEnd);
        cartDrawer?.removeEventListener("transitionend", handleTransitionEnd);
        onComplete?.();
    }

    function handleTransitionEnd(event) {
        if (event.target !== cartWrap && event.target !== cartDrawer) return;
        finish();
    }

    if (!cartWrap || !cartDrawer || cartWrap.classList.contains("bouliesCartLoaded")) {
        finish();
        return;
    }

    timeoutId = window.setTimeout(finish, COLLECTION_ACCESSORIES_CART_DRAWER_OPEN_FALLBACK_MS);
    cartWrap.addEventListener("transitionend", handleTransitionEnd);
    cartDrawer.addEventListener("transitionend", handleTransitionEnd);
}

function getAccessoriesAddToCartErrorMessage(err) {
    if (err?.responseJSON?.description) return err.responseJSON.description;
    if (err?.responseJSON?.message) return err.responseJSON.message;

    if (typeof err?.responseText === "string" && err.responseText !== "") {
        try {
            const errorData = JSON.parse(err.responseText);
            if (errorData.description) return errorData.description;
            if (errorData.message) return errorData.message;
        } catch (error) {}
    }

    if (err?.statusText === "timeout") {
        return "Die Anfrage hat zu lange gedauert. Bitte versuchen Sie es später erneut.";
    }

    return "Etwas ist schiefgelaufen.";
}

function handleAccessoriesAddToCartError(target, err) {
    alert(getAccessoriesAddToCartErrorMessage(err));
    setAccessoriesAddToCartLoadingState(target, false);
}

function updateAccessoriesProductCard(card, swatchButton) {
    const variantPayload = swatchButton.dataset.variantPayload;
    if (!variantPayload) return;

    let variantData = null;
    try {
        variantData = JSON.parse(variantPayload);
    } catch (error) {
        return;
    }

    const imageLink = card.querySelector(".collection-all__product-image-link");
    const titleLink = card.querySelector(".collection-all__product-title-link");
    const image = card.querySelector(".collection-all__product-image");
    const variantText = card.querySelector(".collection-all__product-variant");
    const currentPrice = card.querySelector(".collection-all__current-price");
    const inStockLabel = card.querySelector(".collection-all__product-label--in-stock");
    const outOfStockLabel = card.querySelector(".collection-all__product-label--out-of-stock");
    const form = card.querySelector("form");
    const addToCartButton = form?.querySelector(".collection-all__add-to-cart-btn");
    const isAvailable = variantData.stock_state === "in-stock";

    if (imageLink) imageLink.href = variantData.url;
    if (titleLink) titleLink.href = variantData.url;
    if (image && variantData.image) {
        image.src = variantData.image;
        image.alt = variantData.image_alt;
    }
    if (variantText) variantText.textContent = variantData.label || "";
    if (currentPrice) currentPrice.textContent = variantData.current_price || "";
    if (inStockLabel) inStockLabel.hidden = !isAvailable;
    if (outOfStockLabel) outOfStockLabel.hidden = isAvailable;

    if (form) {
        const variantIdInput = form.querySelector('[name="id"]');
        const estimatedToShipOutInput = form.querySelector('[name="properties[Estimated_to_ship_out]"]');
        const warrantyInput = form.querySelector('[name="properties[warranty]"]');
        const accessoriesInput = form.querySelector('[name="properties[accessories]"]');
        const discountCodeInput = form.querySelector('[name="attributes[cart_discount_code]"]');
        const discountAmountInput = form.querySelector('[name="attributes[cart_discount_amount]"]');

        if (variantIdInput) variantIdInput.value = variantData.id;
        if (estimatedToShipOutInput) {
            estimatedToShipOutInput.value = variantData.estimated_to_ship_out || "";
            estimatedToShipOutInput.disabled = !variantData.estimated_to_ship_out;
        }
        if (warrantyInput) warrantyInput.value = variantData.warranty || "";
        if (accessoriesInput) accessoriesInput.value = variantData.accessories || "";
        if (discountCodeInput) discountCodeInput.value = variantData.discount_code || "";
        if (discountAmountInput) discountAmountInput.value = variantData.discount_amount || "";
    }

    if (addToCartButton) {
        addToCartButton.disabled = !isAvailable;
        addToCartButton.setAttribute("aria-disabled", isAvailable ? "false" : "true");
    }

    card.querySelectorAll(".collection-all__product-swatch").forEach((button) => {
        const isActive = button === swatchButton;
        button.classList.toggle("is-active", isActive);
        button.setAttribute("aria-pressed", isActive ? "true" : "false");
    });
}

function initAccessoriesProductSwatches() {
    document.querySelectorAll(".collection-all__product").forEach((card) => {
        const swatchButtons = card.querySelectorAll(".collection-all__product-swatch");
        swatchButtons.forEach((swatchButton) => {
            swatchButton.addEventListener("click", () => {
                updateAccessoriesProductCard(card, swatchButton);
            });
        });

        const activeSwatchButton = card.querySelector(".collection-all__product-swatch.is-active") || swatchButtons[0];
        if (activeSwatchButton) updateAccessoriesProductCard(card, activeSwatchButton);
    });
}

function initAccessoriesAddToCart() {
    document.querySelectorAll(".collection-all__add-to-cart-btn").forEach((button) => {
        button.addEventListener("click", function (event) {
            event.preventDefault();
            if (button.disabled) return false;

            const form = button.closest("form");
            if (!form) return false;

            addAccessoriesToCart(button, new FormData(form));
        });
    });
}

function addAccessoriesToCart(target, formData) {
    if (target.disabled) return false;

    setAccessoriesAddToCartLoadingState(target, true);

    const itemsData = {
        items: [
            {
                id: formData.get("id"),
                quantity: formData.get("quantity"),
                properties: {
                    warranty: formData.get("properties[warranty]"),
                    accessories: formData.get("properties[accessories]"),
                },
            },
        ],
    };

    if (formData.get("properties[Estimated_to_ship_out]")) {
        itemsData.items[0].properties.Estimated_to_ship_out = formData.get("properties[Estimated_to_ship_out]");
    }

    const attributesData = {
        attributes: {
            cart_discount_code: formData.get("attributes[cart_discount_code]") || "",
            cart_discount_amount: formData.get("attributes[cart_discount_amount]") || "",
        },
    };
    const hasCartDiscountAttributes = attributesData.attributes.cart_discount_code || attributesData.attributes.cart_discount_amount;

    function renderAddedCart(cartData) {
        ajaxcart.updateCartItem(cartData);
        ajaxcart.openCart();
        waitForAccessoriesCartDrawerOpen(function () {
            setAccessoriesAddToCartLoadingState(target, false);
        });
    }

    $.ajax({
        type: "POST",
        dataType: "JSON",
        url: "/cart/add.js",
        data: itemsData,
        timeout: 5000,
        success: function () {
            if (!hasCartDiscountAttributes) {
                $.ajax({
                    type: "GET",
                    dataType: "JSON",
                    url: "/cart.js",
                    timeout: 5000,
                    success: renderAddedCart,
                    error: function (err) {
                        handleAccessoriesAddToCartError(target, err);
                    },
                });
                return;
            }

            $.ajax({
                type: "POST",
                dataType: "JSON",
                url: "/cart/update.js",
                data: attributesData,
                timeout: 5000,
                success: renderAddedCart,
                error: function (err) {
                    handleAccessoriesAddToCartError(target, err);
                },
            });
        },
        error: function (err) {
            handleAccessoriesAddToCartError(target, err);
        },
    });
}

$(document).ready(function () {
    initAccessoriesProductSwatches();
    initAccessoriesAddToCart();
});
